<script setup lang="ts">
import { I18nKey } from '@/utils/typings';
import { mdiPlus } from '@mdi/js';

defineProps<{
  label: I18nKey;
}>();
</script>

<template>
  <TextVBtn class="px-2" size="x-small" :prependIcon="mdiPlus" :text="$t(label)" />
</template>
